export const pricingPlans = [
  {
    slug: "free",
    name: "Free",
    price: "$0",
    period: "forever",
    cta: "Free after month 1",
    selectable: true,
    statusLabel: "",
    popular: false,
    features: [
      {
        key: "inbound-summaries",
        text: "Inbound voice-note summaries",
        detail: "When someone sends you a voice note, Min sends you the summary in a direct WhatsApp message.",
        included: false,
      },
      {
        key: "outbound-summaries",
        text: "Outbound voice-note summaries",
        detail: "When you send a voice note, Min sends a follow-up summary after your message.",
        included: true,
      },
      {
        key: "standard-quality",
        text: "Same quality on every plan",
        detail: "Every plan uses the same transcription and summary models.",
        included: true,
      },
      {
        key: "full-transcripts",
        text: "Full transcripts",
        detail: "See the full text of each voice note, not only the short summary.",
        included: false,
      },
      {
        key: "remove-branding",
        text: "Remove Min branding",
        detail: "Free outputs keep a small Min mention and share link attached.",
        included: false,
      },
      {
        key: "per-chat-controls",
        text: "Per-chat controls",
        detail: "Choose different behavior for different conversations instead of one rule for all.",
        included: false,
      },
    ],
  },
  {
    slug: "fun",
    name: "Fun",
    price: "$1",
    period: "/month",
    cta: "Start 1 month free",
    selectable: true,
    statusLabel: "",
    popular: true,
    features: [
      {
        key: "everything-in-free",
        text: "1 free month included",
        detail: "Everyone starts with Fun for free, then keeps it going at $1/month or earns more time through referrals.",
        included: true,
      },
      {
        key: "full-transcripts",
        text: "Full transcripts",
        detail: "Read every word when you need more than the headline summary.",
        included: true,
      },
      {
        key: "inbound-summaries",
        text: "Inbound voice-note summaries",
        detail: "When someone sends you a voice note, Min can DM you the summary on WhatsApp.",
        included: true,
      },
      {
        key: "approval-mode",
        text: "Approve before send",
        detail: "Turn Automatic off for incoming or outgoing voice notes when you want to react with Ⓜ️ before Min sends results.",
        included: true,
      },
      {
        key: "translation",
        text: "Summaries in another language",
        detail: "Translation for voice notes you send and receive",
        included: true,
      },
      {
        key: "remove-branding",
        text: "Remove Min branding",
        detail: "Keep your shared outputs clean without the Min footer treatment.",
        included: false,
      },
      {
        key: "per-chat-controls",
        text: "Per-chat controls",
        detail: "Set different rules by chat instead of treating every conversation the same.",
        included: false,
      },
      {
        key: "autonomous-help",
        text: "Autonomous WhatsApp help",
        detail: "Upgrade to the higher-touch agent when you want monitoring, escalation, and follow-through.",
        included: false,
      },
    ],
  },
  {
    slug: "pro",
    name: "Pro",
    price: "$10",
    period: "/month",
    cta: "Start with Pro",
    selectable: true,
    statusLabel: "",
    popular: false,
    features: [
      {
        key: "everything-in-fun",
        text: "Everything in Fun",
        detail: "Everything in Fun",
        included: true,
      },
      {
        key: "whatsapp-api",
        text: "WhatsApp API access",
        detail: "Connect your own AI agent with Pro. Your agent handles schedules and approvals.",
        included: true,
      },
      {
        key: "remove-branding",
        text: "Remove Min branding",
        detail: "Outputs can stay fully yours without the Min footer or share prompt.",
        included: true,
      },
      {
        key: "allow-deny-lists",
        text: "Per-chat override table",
        detail: "Add the chats that need custom inbound, outbound, or branding behavior while everything else keeps the global defaults.",
        included: true,
      },
      {
        key: "group-personal-controls",
        text: "Group vs. personal controls",
        detail: "Use one setup for groups and another for one-to-one chats.",
        included: true,
      },
      {
        key: "customization",
        text: "Full customization",
        detail: "Tune the behavior, output style, and defaults to match how you use WhatsApp.",
        included: true,
      },
      {
        key: "autonomous-help",
        text: "Autonomous WhatsApp help",
        detail: "The full agent layer still sits above Pro when you want a more active assistant.",
        included: false,
      },
    ],
  },
  {
    slug: "agent",
    name: "Agent",
    price: "$100",
    period: "/month",
    cta: "Coming soon",
    selectable: false,
    statusLabel: "Coming soon",
    popular: false,
    features: [
      {
        key: "always-on-agent",
        text: "24/7 AI agent",
        detail: "A higher-touch assistant that keeps working even when you are not in WhatsApp.",
        included: true,
      },
      {
        key: "chat-monitoring",
        text: "Monitors the chats that matter",
        detail: "Keep watch on selected chats and surface the moments worth your attention.",
        included: true,
      },
      {
        key: "urgent-escalation",
        text: "Urgent message escalation",
        detail: "Flag the messages that need action now instead of letting them get buried.",
        included: true,
      },
      {
        key: "scheduled-digests",
        text: "Scheduled digests and briefings",
        detail: "Receive regular recaps at the times that fit your day.",
        included: true,
      },
      {
        key: "acts-across-whatsapp",
        text: "Acts in channels, status, and groups",
        detail: "Extend beyond summaries into broader WhatsApp surfaces and workflows.",
        included: true,
      },
      {
        key: "reply-help",
        text: "Reply help and follow-through",
        detail: "Draft replies, suggest next steps, and help close loops that would otherwise linger.",
        included: true,
      },
    ],
  },
];
